var map = {
	"./language-de.json": 59440,
	"./language-en.json": 17079,
	"./language-es.json": 21637,
	"./language-fr.json": 71524,
	"./language-it.json": 55357,
	"./language-nl.json": 71379,
	"./language-zh.json": 59054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1650;